// Skills Images
import HtmlImg from '../assets/html.png';
import CSSImg from '../assets/css.png';
import TailwindImg from '../assets/tailwind.png';
import BootstrapImg from '../assets/bootstrap.png';
import SassImg from '../assets/sass.png';
import JsImg from '../assets/javascript.png';
import ReactJsImg from '../assets/react.png';
import GitHubImg from '../assets/github.png';
import NextImg from '../assets/nextjs.png';
import GitImg from '../assets/git.png';
// Work Images
import Keyboarda from '../assets/keyboarda.png';
import Epoxy from '../assets/epoxy.png';
import Sitechin from '../assets/sitechin.png';
import LandingSitechin from '../assets/landingSitechin.png';
import Defi from '../assets/Defi.png';
import ManageLanding from '../assets/manageLanding.png';
import Bookmark from '../assets/bookmark.png';
import Easybank from '../assets/easybank.png';
import Secured from '../assets/secured.png';
import coffee from '../assets/coffee.png';
import construction from '../assets/construction.png';
import cars from '../assets/car-website-design.png';
import food from '../assets/food.png';
import bootcamp from '../assets/bootcamp.png';
import delivery from '../assets/delivery.png';
import weekaway from '../assets/weekaway.png';
import clipboard from '../assets/clipboard.png';
import dentist from '../assets/dentist.png';
// Navkinks
export const navLinksData = [
  {
    id: 1,
    title: "home",
    path: "home",
  },
  {
    id: 2,
    title: "about",
    path: "about",
  },
  {
    id: 3,
    title: "skills",
    path: "skills",
  },
  {
    id: 4,
    title: "work",
    path: "work",
  },
  {
    id: 5,
    title: "contact",
    path: "contact",
  },
];

// Skills
export const skillData = [
  {
    img: HtmlImg,
    title: 'html',
    alt: 'html'
  },
  {
    img: CSSImg,
    title: 'css',
    alt: 'css'
  },
  {
    img: TailwindImg,
    title: 'tailwind',
    alt: 'tailwind'
  },
  {
    img: BootstrapImg,
    title: 'bootstrap',
    alt: 'bootstrap'
  },
  {
    img: SassImg,
    title: 'sass',
    alt: 'sass'
  },
  {
    img: JsImg,
    title: 'javascript',
    alt: 'javascript'
  },
  {
    img: ReactJsImg,
    title: 'react',
    alt: 'react'
  },
  {
    img: NextImg,
    title: 'next',
    alt: 'next'
  },
  {
    img: GitImg,
    title: 'git',
    alt: 'git'
  },
  {
    img: GitHubImg,
    title: 'github',
    alt: 'github'
  },
]

// Work
export const workData = [
  {
    img:cars,
    title:'cars'
  },
  {
    img:coffee,
    title:'coffee'
  },
  {
    img:construction,
    title:'construction'
  },
  {
    img:food,
    title:'food'
  },
  {
    img:bootcamp,
    title:'bootcamp'
  },
  {
    img:delivery,
    title:'delivery'
  },
  {
    img:weekaway,
    title:'weekaway'
  },
  {
    img:dentist,
    title:'dentist'
  },
  {
    img:clipboard,
    title:'clipboard'
  },
  {
    img:Epoxy,
    title:'epoxy'
  },
  {
    img:Secured,
    title:'secured'
  },
  {
    img:Bookmark,
    title:'bookmark'
  },
  {
    img:ManageLanding,
    title:'manageLanding'
  },
  {
    img:Defi,
    title:'defi'
  },
  {
    img:Easybank,
    title:'easybank'
  },
  {
    img:LandingSitechin,
    title:'landingSitechin'
  },
  {
    img:Keyboarda,
    title:'keyboarda'
  },
  {
    img:Sitechin,
    title:'sitechin'
  },
]